import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/functions'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

export const firebaseConfig = {
  apiKey: 'AIzaSyBvpeSaIwoFaZp56DH_A4N02qIMm2dXP2Y',
  authDomain: 'attunewisetechdemo.web.app',
  projectId: 'attunewisetechdemo',
  storageBucket: 'attunewisetechdemo.appspot.com',
  messagingSenderId: '80135616279',
  appId: '1:80135616279:web:c6694527640d5589dfe952'
}

firebase.initializeApp(firebaseConfig)

export { firebase }
